import { useMemo } from 'react';
import useLiquidityPools from '../pools/useLiquidityPools';
import { Address, Zero } from 'nftx.js';
import { useNetwork } from '@nftx/react';
import { TokenInterface } from '@/core/tokens';
import { getQueryStatus } from '@/infrastructure/utils/getLoadingState';
import { isAddressWeth } from '@/domain/ticks/helpers';

const useTokens = () => {
  const network = useNetwork();
  const {
    data: liquidityPools,
    status,
    error,
    fetchStatus,
  } = useLiquidityPools();
  const tokens = useMemo(() => {
    if (!liquidityPools) {
      return;
    }
    // Group all pools by vToken
    const poolsByToken = liquidityPools.reduce((acc, pool) => {
      const inputToken = isAddressWeth(pool.tokens[0].id, network)
        ? pool.tokens[1]
        : pool.tokens[0];
      const id = inputToken.id;

      // Filter out dead pools
      // if (pool.totalValueLocked <= 0n) {
      //   return acc;
      // }

      let token = acc[id];
      if (!token) {
        token = acc[id] = {
          id,
          name: inputToken.name,
          symbol: inputToken.symbol,
          vaultId: pool.vaultId,
          dailyTotalRevenue: Zero,
          dailyTotalVolume: Zero,
          totalValueLocked: Zero,
          weeklyTotalRevenue: Zero,
          weeklyTotalVolume: Zero,
          pools: [],
        };
      }

      if (pool.exists) {
        token.pools.push(pool);
        token.dailyTotalRevenue += pool.dailyRevenue;
        token.dailyTotalVolume += pool.dailyVolume;
        token.totalValueLocked += pool.totalValueLocked;
        token.weeklyTotalRevenue += pool.weeklyRevenue;
        token.weeklyTotalVolume += pool.weeklyVolume;
      }

      return acc;
    }, {} as Record<Address, TokenInterface>);

    return Object.values(poolsByToken).sort((a, b) => {
      return Number(b.totalValueLocked) - Number(a.totalValueLocked);
    });
  }, [liquidityPools, network]);

  return {
    status: getQueryStatus(status, fetchStatus),
    error,
    data: tokens,
  };
};

export default useTokens;
